<template>
    <v-ons-list class="section-h">
        <v-ons-list-item @click="show_alert = true" modifier="chevron">
            <span class="prompt-text">
                <i class="fa fa-check" aria-hidden="true"></i>
                End User License Agreement
            </span>
            <v-ons-alert-dialog
                    title="End User License Agreement"
                    v-bind:visible.sync="show_alert"
                    v-bind:footer="{
                        Close: () => show_alert = false,
                        Accept: () => {
                            accepted = true
                            show_alert = false
                        },
                    }">
                <div class="eula-container">
                    <eula-text v-bind:can_accept="true"></eula-text>
                </div>
            </v-ons-alert-dialog>
        </v-ons-list-item>
        <v-ons-list-item>
            <div class="center">
                <label>
                    <v-ons-checkbox v-model="accepted"></v-ons-checkbox>
                    I have read and accept the EULA
                </label>
            </div>
        </v-ons-list-item>
    </v-ons-list>
</template>

<script>
import EulaText from "./eula_text";

export default {
    name: "eula_prompt_list",

    components: {
        'eula-text': EulaText,
    },

    data(){
        return {
            accepted: false,
            show_alert: false,
        }
    },

    watch: {
        accepted(new_value){
            this.$emit('acceptChanged', new_value)
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/fragments/eula_prompt_list.vue